<template>
  <div>
    <div>
      <div class="proj-toolbox-admin">
        <div class="proj-toolbox-title">
          <i class="fa fa-wrench block-text"></i>{{ $t("menu.toolbox") }}：{{
            $t("menu.add_device_to_the_cropping_season")
          }}
        </div>

        <b-row>
          <b-col md="8">
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text
                  ><i class="fa fa-plus"></i
                  >{{ $t("n.device") }}</b-input-group-text
                >
              </b-input-group-prepend>
              <b-form-select
                v-model="add_device.hashid"
                :options="list_devices"
                :select-size="4"
              ></b-form-select>
            </b-input-group>
          </b-col>
          <b-col md="4">
            <div class="text-right">
              <b-button
                variant="danger"
                class="px-4 btn-upload btn-red"
                @click="add_deviceInfo"
                :disabled="uploading || checkDisabled_add"
              >
                <i class="fa fa-plus"></i
                >{{ $t("menu.add_device_to_the_cropping_season") }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <h4>
      {{ $t("menu.devices_in_cropping_season") }}
      <b-badge class="badge-small">{{ devices.length }}</b-badge>
    </h4>
    <div v-for="(device_in_cp, idx_dev_in_cp) in devices" :key="idx_dev_in_cp">
      <div class="clickable" @click.prevent="editDeviceInfo(device_in_cp)">
        <b-alert variant="success" show>
          <i
            :class="$tools.style.classIcon(device_in_cp.type, 'block-text')"
          ></i
          >{{ $t("n." + device_in_cp.type) }}
          <span v-if="device_in_cp.nickname" class="block-text"
            >- {{ device_in_cp.nickname }}</span
          >
          <div class="block-text device-info-hashid">
            {{ device_in_cp.hashid }}
          </div>
          <div class="block-text device-info-hashid" v-if="user_admin">
            ( Device ID = {{ device_in_cp.deviceid }} )
          </div>

          <b-button
            variant="outline-dark"
            class="btn-delete"
            @click="remove_confirm(device_in_cp)"
            :disabled="uploading"
          >
            <i class="fa fa-times"></i>
            <!-- {{ $t('menu.remove_device_from_the_cropping_season') }} -->
          </b-button>
        </b-alert>
      </div>

      <div
        v-if="edit_device && edit_device.hashid == device_in_cp.hashid"
        class="device-info-area"
        id="device-editor"
      >
        <b-row>
          <b-col md="4">
            <div class="block-text device-info-type">
              <i
                :class="$tools.style.classIcon(edit_device.type, 'block-text')"
              ></i
              >{{ $t("n." + edit_device.type) }}
            </div>
            <div class="block-text device-info-hashid">
              {{ edit_device.hashid }}
            </div>
            <div class="block-text device-info-hashid" v-if="user_admin">
              ( Device ID = {{ edit_device.deviceid }} )
            </div>

            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text
                  ><i class="icon-pencil"></i
                  >{{ $t("menu.name") }}</b-input-group-text
                >
              </b-input-group-prepend>
              <b-form-input
                type="text"
                class="form-control"
                v-model.trim="edit_device.nickname"
                :disabled="!checkEditable(edit_device)"
                :maxlength="
                  $tools.input.getInputMaxLength('device', 'nickname')
                "
              />
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text
                  ><i class="icon-menu"></i
                  >{{ $t("menu.description") }}</b-input-group-text
                >
              </b-input-group-prepend>
              <b-form-textarea
                type="text"
                v-model="edit_device.description"
                :disabled="!checkEditable(edit_device)"
                :rows="2"
                :max-rows="6"
              ></b-form-textarea>
            </b-input-group>
          </b-col> </b-row
        ><!-- end b-row -->

        <div v-if="user_admin">
          <b-row>
            <!-- Status -->
            <!-- <b-col md="8">
                            <div>
                                <div class="block-sm">
                                    {{ $t('n.device') }} {{ $t('menu.status') }}
                                </div>
                                <div class="block-sm">
                                    <b-form-radio-group v-model="edit_device.status" :plain="true" buttons>
                                        <template v-for="(status, idx_status) in admin_DeviceStatus_List">
                                            <b-form-radio
                                                v-if="status.editable"
                                                :key="idx_status"
                                                :value="status.value"
                                                :button-variant="status.buttonVariant"
                                                :disabled="! checkEditable( edit_device )"
                                            >
                                                {{ $t('status.device.' + status.value) }}
                                            </b-form-radio>
                                        </template>
                                    </b-form-radio-group>
                                </div>
                            </div>
                        </b-col> -->
            <b-col md="6">
              <b-input-group class="mb-3">
                <!-- 緯度 -->
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa fa-map-pin"></i
                    >{{ $t("menu.latitude") }}</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model="edit_device.latitude"
                  :state="checkLatitude(edit_device.latitude)"
                  :disabled="!checkEditable(edit_device)"
                ></b-form-input>
                <!-- 經度 -->
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa fa-map-pin"></i
                    >{{ $t("menu.longitude") }}</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model="edit_device.longitude"
                  :state="checkLongtitude(edit_device.longitude)"
                  :disabled="!checkEditable(edit_device)"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </div>
        <!-- end if user_admin -->

        <b-row>
          <b-col md="8">
            <b-input-group class="mb-3" v-if="user_admin">
              <b-input-group-prepend>
                <b-input-group-text
                  ><i class="icon-menu"></i
                  >{{ $t("menu.admin_note") }}</b-input-group-text
                >
              </b-input-group-prepend>
              <b-form-textarea
                type="text"
                v-model="edit_device.note"
                :disabled="!checkEditable(edit_device)"
                :rows="1"
                :max-rows="6"
              ></b-form-textarea>
            </b-input-group>
          </b-col>
          <b-col md="4" align-self="end">
            <div class="text-right">
              <b-button
                variant="dark"
                class="px-4 btn-upload"
                @click="remove_confirm(edit_device)"
                :disabled="uploading"
              >
                <i class="fa fa-minus"></i
                >{{ $t("menu.remove_device_from_the_cropping_season") }}
              </b-button>

              <b-button
                v-if="checkEditable(edit_device)"
                variant="success"
                class="px-4 btn-upload"
                @click="upload_deviceInfo(edit_device)"
                :disabled="uploading || checkDisabled(edit_device)"
              >
                {{ $t("menu.save_changes") }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Modal: confirm delete -->
    <b-modal
      v-model="confirm_show_delete"
      :title="$t('other.confirm_delete')"
      header-bg-variant="dark"
      hide-header-close
      hide-footer
    >
      <h4>{{ $t("other.enter_confirmation_code") }}：{{ confirm_text }}</h4>
      <b-form-input
        type="text"
        :placeholder="$t('other.enter_confirmation_code')"
        v-model="confirm_answer"
      ></b-form-input>
      <div class="text-center">
        <button
          type="button"
          class="btn btn-secondary btn-upload"
          @click.prevent="confirm_show_delete = false"
          :disabled="uploading"
        >
          <i class="fa fa-close"></i> {{ $t("menu.cancel") }}
        </button>

        <b-button
          variant="success"
          class="px-4 btn-upload"
          @click="remove_deviceInfo(confirm_device)"
          :disabled="confirm_text != confirm_answer"
          >{{ $t("menu.remove_device_from_the_cropping_season") }}</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    cropperiodID: {
      type: [String, Number],
      default: undefined,
    },
    isCreateNew: {
      type: Boolean,
      default: false,
    },
    timezone: {
      type: String,
      default: "Asia/Taipei",
    },
  },
  data() {
    return {
      uploading: false,
      devices: [],

      // confirm
      confirm_show_delete: false,
      confirm_text: "",
      confirm_answer: "",
      confirm_device: undefined,

      // add device
      add_device: {
        hashid: "",
        cropperiodID: 0,
      },

      // edit device
      edit_device: undefined,
    };
  },
  mounted() {
    this.set_deviceList();
    if (this.cropperiodID != undefined)
      this.add_device.cropperiodID = this.cropperiodID;
  },
  computed: {
    ...mapState({
      user_admin: (state) => state.user.is_admin,
      cropperiod_detail: (state) => state.cropperiod.cropperiod,
      project_detail: (state) => state.project.project_detail,
      project_devices: (state) => state.project.project_devices,
      project_editable: (state) => state.project.project_editable,
      admin_DeviceStatus_List: (state) => state.device.list_status,
    }),

    list_devices() {
      let _devicesList = [];

      if (this.project_devices) {
        this.project_devices.gateways.forEach((_gateway) => {
          if (this.user_admin == true) {
            _devicesList.push({
              value: _gateway.hashid,
              text: `【 ${_gateway.hashid} (ID=${_gateway.gatewayid}) ${
                _gateway.nickname ? _gateway.nickname : " "
              } 】`,
              disabled: true,
            });
          }
          _gateway.devices.forEach((_device) => {
            let _disabled = false;
            this.devices.forEach((_d) => {
              if (_d.hashid == _device.hashid) _disabled = true;
            });

            if (_disabled == false) {
              _devicesList.push({
                value: _device.hashid,
                text: `${_device.hashid} (ID=${_device.deviceid}) ${
                  _device.nickname ? _device.nickname : " "
                }`,
              });
            }
          });
        });
      }

      return _devicesList;
    },

    // 檢查新增裝置到期作的按鈕是否 disabled
    checkDisabled_add() {
      if (this.$tools.input.checkRequired(this.add_device.hashid) == false)
        return true;
      if (this.add_device.cropperiodID == undefined) return true;

      return false;
    },
  },
  watch: {
    // 偵測到 [ 期作資訊 ] 變動就更新感測器清單
    cropperiod_detail() {
      if (this.cropperiodID != undefined) {
        this.init_cropperiod();
        this.set_deviceList();
      }
    },
  },
  methods: {
    // 檢查裝置是否可以編輯
    checkEditable(device) {
      let _device_type = device.hashid[0] + device.hashid[1];
      if (_device_type == "WD") {
        return false;
      }
      return true;
    },

    // 因為有傳入參數，故寫在 methods 而不是 computed
    checkLatitude(value) {
      return this.$tools.input.checkFloat(value);
    },
    checkLongtitude(value) {
      return this.$tools.input.checkFloat(value);
    },
    checkDisabled(device) {
      if (this.checkLatitude(device.latitude) == false) return true;
      if (this.checkLongtitude(device.longitude) == false) return true;
      return false;
    },

    editDeviceInfo(device) {
      // 如果點擊自己就關閉
      if (
        this.edit_device != undefined &&
        this.edit_device.hashid == device.hashid
      ) {
        this.edit_device = undefined;
      } else {
        this.edit_device = device;

        // 移動到編輯區域
        // window.location.hash = '#device-editor'
      }
    },

    init_cropperiod() {
      this.add_device.cropperiodID = this.cropperiodID;
    },

    // 更新期作資料
    getCropperiod() {
      // console.log(this.cpID + ' ?' + Math.random());
      if (this.cropperiodID) {
        this.$store
          .dispatch("cropperiod/getCropperiod", this.cropperiodID)
          .then((res) => {
            this.set_deviceList();
          })
          .catch((err) => {});
      }
    },

    // 更新介面上的感測器資料
    set_deviceList() {
      this.devices = [];
      this.edit_device = undefined;

      if (
        this.cropperiodID != undefined &&
        this.cropperiod_detail &&
        this.cropperiod_detail.devices
      ) {
        this.cropperiod_detail.devices.forEach((_device) => {
          this.devices.push({
            cropperiodID: this.cropperiodID,
            hashid: _device.hashid,
            deviceid: _device.deviceid,
            nickname: _device.nickname,
            description: _device.description,
            type: _device.type,
            latitude: _device.latitude,
            longitude: _device.longitude,
            status: _device.status
              ? _device.status
              : this.admin_DeviceStatus_List[0].value,
            sensor_params: _device.sensor_params,
            visualization: _device.visualization,
            note: _device.note,
          });
        });
      }
    },

    modal_init(device) {
      this.confirm_show_delete = false;
      this.confirm_text = this.$tools.input.randomCode();
      this.confirm_answer = "";
      this.confirm_device = device;
    },
    remove_confirm(device) {
      this.modal_init(device);
      this.confirm_show_delete = true;
    },

    // 上傳並更新專案基礎資訊
    upload_deviceInfo(device) {
      this.uploading = true;
      let _API_URL = this.$config.getAPI_URL("Update_Cropperiod_Device_Info", {
        cropperiodID: device.cropperiodID,
        deviceID: device.hashid,
      });
      let _data = {
        nickname: device.nickname,
        description: device.description,
      };

      if (this.user_admin) {
        _API_URL = this.$config.getAPI_URL("Admin_Device", {
          deviceID: device.hashid,
        });

        _data.status = device.status;
        if (device.latitude) {
          _data.latitude = parseFloat(device.latitude).toFixed(6);
        } else {
          _data.latitude = null;
        }
        if (device.longitude) {
          _data.longitude = parseFloat(device.longitude).toFixed(6);
        } else {
          _data.longitude = null;
        }
        _data.note = device.note;
      }

      const options = {
        method: "PUT",
        url: _API_URL,
        data: _data,
      };
      this.$http(options)
        .then((res) => {
          this.getCropperiod();
          this.uploading = false;
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.device_information") + ": " + device.nickname
          );
        })
        .catch((err) => {
          // console.log(err);
          this.set_deviceList();
          this.uploading = false;
          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            this.$t("menu.device_information") + ": " + device.nickname
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "cropperiod",
          action: "update device info",
          querySettings: {
            "cropperiod ID": this.cropperiod_detail.id,
            "cropperiod name": this.cropperiod_detail.name,
            "cropperiod status": this.cropperiod_detail.status,
            "device ID": device.deviceid,
            "device HashID": device.hashid,
            "device type": device.type,
            "device nickname": device.nickname,
          },
          pageInfo: {
            "project ID": this.project_detail.id,
            "project name": this.project_detail.name,
            "user role": this.project_detail.user_role,
            "project status": this.project_detail.status,
            "service level": this.project_detail.service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    // 新增裝置到期作
    add_deviceInfo() {
      this.uploading = true;
      let _data = {
        device_hash_id: this.add_device.hashid,
      };
      const options = {
        method: "POST",
        url: this.$config.getAPI_URL("Update_Cropperiod_Device_link", {
          cropperiodID: this.add_device.cropperiodID,
        }),
        data: _data,
      };
      this.$http(options)
        .then((res) => {
          this.getCropperiod();
          this.uploading = false;
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.add_device_to_the_cropping_season") +
              ": " +
              this.add_device.hashid
          );
        })
        .catch((err) => {
          // console.log(err);
          this.add_device.hashid = "";

          this.uploading = false;
          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            this.$t("menu.add_device_to_the_cropping_season") +
              ": " +
              this.add_device.hashid
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "cropperiod",
          action: "link device",
          querySettings: {
            "cropperiod ID": this.cropperiod_detail.cropperiodID,
            "cropperiod name": this.cropperiod_detail.name,
            "device HashID": this.add_device.hashid,
          },
          pageInfo: {
            "project ID": this.project_detail.id,
            "project name": this.project_detail.name,
            "user role": this.project_detail.user_role,
            "project status": this.project_detail.status,
            "service level": this.project_detail.service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },
    // 從期作移除裝置
    remove_deviceInfo(device) {
      this.confirm_show_delete = false;
      this.uploading = true;
      let _data = {
        device_hash_id: device.hashid,
      };
      const options = {
        method: "DELETE",
        url: this.$config.getAPI_URL("Update_Cropperiod_Device_link", {
          cropperiodID: device.cropperiodID,
        }),
        data: _data,
      };
      this.$http(options)
        .then((res) => {
          this.getCropperiod();
          this.uploading = false;
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.remove_device_from_the_cropping_season") +
              ": " +
              device.hashid
          );
        })
        .catch((err) => {
          // console.log(err);
          this.getCropperiod();
          this.uploading = false;

          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            this.$t("menu.remove_device_from_the_cropping_season") +
              ": " +
              device.hashid
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "cropperiod",
          action: "unlink device",
          querySettings: {
            "cropperiod ID": this.cropperiod_detail.cropperiodID,
            "cropperiod name": this.cropperiod_detail.name,
            "device ID": device.deviceid,
            "device HashID": device.hashid,
            "device type": device.type,
            "device status": device.status,
            "device nickname": device.nickname,
          },
          pageInfo: {
            "project ID": this.project_detail.id,
            "project name": this.project_detail.name,
            "user role": this.project_detail.user_role,
            "project status": this.project_detail.status,
            "service level": this.project_detail.service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-delete {
  float: right;
  width: 20px;
  padding: 1px 0px 2px 6px;
}

.device-info-area {
  padding: 10px 0px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e0e4db;
}
.device-info-hashid {
  font-size: 0.8rem;
  color: #209070;
}
.device-info-type {
  font-size: 0.95rem;
  padding: 5px 10px;
  color: #385f53;
  background-color: #b8da8c;
  border-radius: 5px 5px 0px 0px;
}
</style>
